import { Page } from '@app/components/page/Page';
import { SocialExportBreadcrumbs } from '@app/modules/social-export/components/breadcrumbs/SocialExportBreadcrumbs';
import { socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { PlatformUploaded } from './PlatformUploaded';

/**
 * Admin page listing recently published videos for a social platform.
 */
export function SocialExportUploadedPage() {
  const { platform: platformKey } = useParams<{ platform: string }>();
  const platform = socialPlatforms.get(platformKey)!;
  const { $t } = useIntl();

  const title = $t({
    id: 'socialExport.uploaded.title',
    defaultMessage: 'Últimos videos publicados',
  });

  return (
    <Page htmlTitle={title}>
      <Page.Header
        icon={platform.Icon()}
        title={title}
        breadcrumbs={<SocialExportBreadcrumbs platform={platform} />}
      />
      <PlatformUploaded platform={platform} />
    </Page>
  );
}
